import { Injectable } from '@angular/core';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';

@Injectable()
export class LoginPersistenceService {
  public hasBookingData: boolean;
  public hasCharterData: boolean;
  public captain: Captain;
  public waterBody: WaterBody;
  public bookingModel: any;
  public charterId: number;

  constructor() {
    this.hasBookingData = false;
  }

  public setBookingModel(bookingData: any) {
    this.bookingModel = bookingData;
  }

  public getBookingModel(): any {
    return this.bookingModel;
  }

  public setHasBookingData(hasBookingData: boolean) {
    this.hasBookingData = hasBookingData;
  }

  public getHasBookingData(): boolean {
    return this.hasBookingData;
  }

  public setHasCharterData(bool: boolean) {
    this.hasCharterData = bool;
  }

  public getHasCharterData(): boolean {
    return this.hasCharterData;
  }

  public getCaptainId(): number {
    return this.captain.id;
  }

  public setCharterId(id: number) {
    this.charterId = id;
  }

  public getCharterId(): number {
    return this.charterId;
  }

  public setCaptain(captain: Captain) {
    this.captain = captain;
  }

  public setWaterBody(waterBody: WaterBody) {
    this.waterBody = waterBody;
  }

  public getCaptain() {
    return this.captain;
  }

  public getWaterBody() {
    return this.waterBody;
  }
}
